import Vue from 'vue'
import api from '@/lib/hippo'
import Broadcast from '@/models/broadcast';

function initialState() {
    return {
        broadcasts: {}
    };
}

const state = initialState;

const getters = {
    getBroadcastMessages: (state) => (Object.keys(state.broadcasts).length > 0) ? state.broadcasts : false,
    getBroadcast: (state) => (id) => state.manageBroadcasts[id]
};

const actions = {

    fetchBroadcasts({commit, state, rootGetters}) {
      return new Promise((resolve, reject) => {
          if (rootGetters.apiToken) {
              api.getBroadcasts(rootGetters.apiToken)
                  .then( (response) => {
                      if (response.data.data.length > 0) commit ('setBroadcasts', Broadcast.from(response.data) );
                      resolve(true);
                 }).catch( (err) => reject(err) );
          } // else {
          //     reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
          // }
      });
    },
    fetchPublicBroadcasts({commit, state, rootGetters}) {
      return new Promise((resolve, reject) => {
              api.getPublicBroadcasts()
                  .then( (response) => {
                      if (response.data.data.length > 0) commit ('setBroadcasts', Broadcast.from(response.data) );
                      resolve(true);
                 }).catch( (err) => reject(err) );
           // else {
          //     reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
          // }
      });
    },
    dismissBroadcast({commit, state, rootGetters}, id) {
      return new Promise((resolve, reject) => {
          if (rootGetters.apiToken) {
              api.deleteBroadcast(rootGetters.apiToken, id)
                  .then( (response) => {
                      commit('removeBroadcast', id);
                      resolve(true);
                 }).catch((err) => reject(err));
          } else {
              reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
          }
      });
    },
    viewedBroadcast({commit, state, rootGetters}, id) {
        // removes broadcast from Store.state
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.putBroadcast(rootGetters.apiToken, id)
                    .then((response) => {
                        let cast = Broadcast.from(response.data);
                        commit ('setBroadcast', {id, cast} );
                        resolve(true);
                   }).catch((err) => reject(err));
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },

    resetBroadcastsState({commit}) {
        commit('resetState');
    }
};

const mutations = {
    setBroadcasts: (state, casts) => {
        Vue.set(state, 'broadcasts', casts);
    },
    setBroadcast: (state, {id, cast}) => {
        Vue.set(state.broadcasts, id, cast);
    },
    removeBroadcast: (state, id) => {
        Vue.delete(state.broadcasts, id);
    },

    resetState ( state ) {
        const s = initialState();
        Object.keys(s).forEach(key => {
            Vue.set(state, key, s[key]);
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
